export default "__VITE_ASSET__BL9wg4$p__"